// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__3W44u","label":"LabeledBox_label__3efXB"};